// extracted by mini-css-extract-plugin
module.exports = {"component":"AppPageHeader_component__2WnTH"};